import { useConvexAuth } from 'convex/react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../shared/LanguageSelector';

export default function ChallengePublicLayout({ children }) {
  const { t } = useTranslation();
  const { isAuthenticated } = useConvexAuth();

  return (
    <div className="ch">
      <nav className="ch-nav">
        <a href="/landing" className="ch-nav-logo" data-no-translate="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5l6.74-6.76z" />
            <line x1="16" y1="8" x2="2" y2="22" />
            <line x1="17.5" y1="15" x2="9" y2="15" />
          </svg>
          Share-Pen
        </a>
        <div className="ch-nav-links">
          <a href="/landing">{t('common.home')}</a>
          <a href="/docs">{t('docs.title')}</a>
          <a href="/projects/community">{t('common.community')}</a>
        </div>
        <div className="ch-nav-spacer" />
        <div className="ch-nav-actions">
          <LanguageSelector className="ch-nav-language" />
          {isAuthenticated ? (
            <>
              <a href="/projects/challenges" className="ch-nav-login">
                {t('challengesRuntime.workspace.nav', { defaultValue: 'My challenges' })}
              </a>
              <a href="/projects" className="ch-nav-cta">
                {t('projects.projectHome', { defaultValue: 'Projects' })}
              </a>
            </>
          ) : (
            <>
              <a href="/projects?mode=signin" className="ch-nav-login">
                {t('landing.nav.logIn')}
              </a>
              <a href="/projects?mode=signup" className="ch-nav-cta">
                {t('landing.nav.startWriting')}
              </a>
            </>
          )}
        </div>
      </nav>

      <main className="ch-route-shell">{children}</main>

      <footer className="ch-footer">
        <div className="ch-container">
          <div className="ch-footer-brand">Share-Pen</div>
          <div className="ch-footer-links">
            <a href="/landing">{t('common.home')}</a>
            <a href="/docs">{t('docs.title')}</a>
            <a href="/challenges">{t('landing.nav.challenges')}</a>
            <a href="/projects/community">{t('landing.nav.community')}</a>
          </div>
          <p>© 2026 Share-Pen. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
